import { useEffect } from "react"

export const useAsyncEffect = (action: () => Promise<any>, deps?: any[]) => 
{
    useEffect(() => { (async () => action())() }, deps)
}